 /*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */
 import { apiFetch } from '../../../apiClient';
 import { getSessionDatas } from '../../../utils';
 import { showLoaing } from '../../App/state/action';
 import { apiMap, settings } from '../../../config/constants';

export const ApplicantInformation_Handle = 'ApplicantInformation_Handle';

export const applicantInformationHandle = (data) =>({
    type: ApplicantInformation_Handle,
    data
});

export const applicantInformationHandleAction = (data) => dispatch => {
    dispatch(applicantInformationHandle(data));
}

export const savePQForm = (section) => dispatch => {
    dispatch(showLoaing(true));
    const { applicationId } = getSessionDatas();
    const updateApplicationParams = {
        hostname: settings.hostBusiness,
        paramsObj: {
            businessInfo: {
                appId: applicationId,
                ...section
            }
        },
        method: settings.put,
    };
    return apiFetch(apiMap.updateBusiness, updateApplicationParams)(dispatch)
                .then(res => {
                    dispatch(showLoaing(false));
                    return res;
                })
                .catch(error => {
                    dispatch(showLoaing(false));
                    throw error;
                })
 }



// WEBPACK FOOTER //
// ./src/views/ApplicantInformation/state/action.js